// ----------------------------------------------------------------------------
// Collection filters
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import '../../snippets/_containers/modal/modal';

// Styles
import './_collection-filters-sort.scss';

// -------------------------------------
// Variables
// -------------------------------------
// Selectors
var FILTER_WRAPPER = '#FiltersWrapperDesktop';
var PRODUCT_COUNT = '#ProductCount';
var PRODUCT_GRID_CONTAINER = '#ProductGridContainer';
var PRODUCT_GRID = '#ProductGrid';
var FILTER_DETAILS_ELEMENTS = '#FiltersForm .js--filter, #FiltersFormMobile .js--filter';
var FILTER_ELEMENT = '.js--filter';
var FILTER_FORMS_SELECTORS = '#FiltersForm, #FiltersFormMobile';
var ACTIVE_FILTER_MOBILE = '.js--active-filters-mobile';
var ACTIVE_FILTER_DESKTOP = '.js--active-filters-desktop';
var FILTERS_SELECTED = '.js--filters__selected';
var FILTERS_SUMMARY = '.js--filters__summary';
var SORT_SELECTOR = '#SortBy';
var FILTERS_FORM_SELECTOR = '#FiltersForm';

// Classes, IDs & Other
var PRODUCT_GRID_CONTAINER_ID = 'ProductGridContainer';
var FILTERS_FORM_ID = 'FiltersForm';
var SORT_FORM_ID_DESKTOP = 'SortForm';
var SORT_FORM_ID_MOBILE = 'SortFormMobile';
var LOADING_CLASS = 'loading';
var CLOSED_FILTERS_CLASS = 'closed-filters--mobile';
var OPEN_ATTR = 'open';

// -------------------------------------
// Hooks
// -------------------------------------

// Class 'FiltersForm' to handle filter functionalities
class FiltersForm extends HTMLElement {
  constructor() {
    // Initializing event handlers and methods for filtering
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    // Debouncing the submit handler to avoid frequent submissions
    this.debouncedOnSubmit = debounce(event => {
      this.onSubmitHandler(event);
    }, 500);

    // Adding event listeners for filter form input and keyup actions
    var filterForm = this.querySelector('form');
    filterForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    // Adding an event listener for the escape key to close details elements
    var filterWrapper = this.querySelector(FILTER_WRAPPER);
    if (filterWrapper) filterWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  // Static method to set listeners for popstate events
  static setListeners() {
    var onHistoryChange = event => {
      var searchParams = event.state ? event.state.searchParams : FiltersForm.searchParamsInitial;
      if (searchParams === FiltersForm.searchParamsPrev) return;
      FiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  // Static method to render the page with updated filter parameters
  static renderPage(searchParams, event) {
    var updateURLHash = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // Implementation details for rendering different sections of the page
    FiltersForm.searchParamsPrev = searchParams;
    var sections = FiltersForm.getSections();
    var countContainer = document.querySelector(PRODUCT_COUNT);
    if (countContainer) {
      countContainer.classList.add(LOADING_CLASS);
    }
    sections.forEach(section => {
      // Construct the appropriate URL based on the page type
      var url = "".concat(window.location.pathname, "?section_id=").concat(section.section, "&").concat(searchParams);
      var filterDataUrl = element => element.url === url;
      FiltersForm.filterData.some(filterDataUrl) ? FiltersForm.renderSectionFromCache(filterDataUrl, event) : FiltersForm.renderSectionFromFetch(url, event);
    });

    // Updating the URL hash if required
    if (updateURLHash) FiltersForm.updateURLHash(searchParams);
  }
  static renderSectionFromFetch(url, event) {
    fetch(url).then(response => response.text()).then(responseText => {
      var html = responseText;
      FiltersForm.filterData = [...FiltersForm.filterData, {
        html,
        url
      }];
      FiltersForm.renderFilters(html, event);
      FiltersForm.renderProductGridContainer(html);
      FiltersForm.renderProductCount(html);
      FiltersForm.renderNoResultsMessage(html);
    });
  }
  static renderSectionFromCache(filterDataUrl, event) {
    var html = FiltersForm.filterData.find(filterDataUrl).html;
    FiltersForm.renderFilters(html, event);
    FiltersForm.renderProductGridContainer(html);
    FiltersForm.renderProductCount(html);
    FiltersForm.renderNoResultsMessage(html);
  }
  static renderProductGridContainer(html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var newContent = doc.querySelector(PRODUCT_GRID_CONTAINER);
    if (newContent) {
      document.getElementById(PRODUCT_GRID_CONTAINER_ID).innerHTML = newContent.innerHTML;
    } else {
      console.error('ProductGridContainer not found in the fetched HTML');
    }
  }
  static renderProductCount(html) {
    var countContainers = document.querySelectorAll(PRODUCT_COUNT);
    var parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    var counts = parsedHTML.querySelectorAll(PRODUCT_COUNT);
    if (countContainers) {
      countContainers.forEach((container, index) => {
        if (counts[index]) {
          // Update innerHTML
          container.innerHTML = counts[index].innerHTML;

          // Update data-product-count attribute
          var dataProductCount = counts[index].getAttribute('data-product-count');
          container.setAttribute('data-product-count', dataProductCount);
          container.classList.remove(LOADING_CLASS);
        }
      });
    }
  }
  static renderNoResultsMessage() {
    var countContainers = document.querySelector(PRODUCT_COUNT);
    var productCountValue = countContainers.getAttribute('data-product-count');
    if (productCountValue) {
      if (productCountValue === '0') {
        document.querySelector(PRODUCT_GRID).innerHTML = '<p class="no-results-text">' + window.translations.noResultsFound + '</p>';
      }
    }
  }
  static renderFilters(html, event) {
    var _event$target;
    var parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    var filterDetailsElements = parsedHTML.querySelectorAll(FILTER_DETAILS_ELEMENTS);
    var focusedFilterId = event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.id;
    var filterForms = Array.from(document.querySelectorAll(FILTER_FORMS_SELECTORS));
    filterForms.forEach(form => {
      var sourceForm = parsedHTML.querySelector("#".concat(form.id));
      if (!sourceForm) return;
      var targetFiltersForm = form.closest('filters-form') || form;
      var sourceFiltersForm = sourceForm.closest('filters-form') || sourceForm;
      var openStates = new Map(Array.from(targetFiltersForm.querySelectorAll(FILTER_ELEMENT)).map(filter => [filter.dataset.index, filter.hasAttribute(OPEN_ATTR)]));
      var replacement = sourceFiltersForm.cloneNode(true);
      targetFiltersForm.replaceWith(replacement);
      replacement.querySelectorAll(FILTER_ELEMENT).forEach(filter => {
        var wasOpen = openStates.get(filter.dataset.index);
        if (wasOpen) {
          filter.setAttribute(OPEN_ATTR, true);
        } else {
          filter.removeAttribute(OPEN_ATTR);
        }
      });
    });
    FiltersForm.renderActiveFilters(parsedHTML);
    if (focusedFilterId) {
      var focusedElement = document.getElementById(focusedFilterId);
      if (focusedElement) focusedElement.focus();
    }
  }
  static renderActiveFilters(html) {
    var activeFilterElementSelectors = [ACTIVE_FILTER_MOBILE, ACTIVE_FILTER_DESKTOP];
    activeFilterElementSelectors.forEach(selector => {
      var activeFiltersElement = html.querySelector(selector);
      if (!activeFiltersElement) return;
      document.querySelector(selector).innerHTML = activeFiltersElement.innerHTML;
    });
  }
  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', "".concat(window.location.pathname).concat(searchParams && '?'.concat(searchParams)));
  }
  static getSections() {
    return [{
      section: document.querySelector(PRODUCT_GRID).dataset.id
    }];
  }

  // Handling event changes for sorting selectors
  connectedCallback() {
    var sortSelectors = document.querySelectorAll(SORT_SELECTOR);
    if (sortSelectors.length > 0) {
      sortSelectors.forEach(sortSelector => {
        sortSelector.addEventListener('change', this.handleSelectorChange.bind(this));
      });
    }
    this.toggleCollapsibleFilters();
  }
  toggleCollapsibleFilters() {
    var seeMoreButtons = this.querySelectorAll('[data-see-more]');
    seeMoreButtons.forEach(button => {
      button.addEventListener('click', event => {
        event.preventDefault();
        var type = button.getAttribute('data-see-more');
        var isCollapsed = button.getAttribute('data-is-collapsed');
        var filters = this.querySelectorAll("[data-collapsible-filter=\"".concat(type, "\"]"));
        if (!filters) return;
        if (isCollapsed == 'true') {
          filters.forEach(filter => filter.classList.remove('filters__item--hidden'));
          button.innerText = 'See Less';
          button.dataset.isCollapsed = 'false';
        } else {
          filters.forEach(filter => filter.classList.add('filters__item--hidden'));
          button.innerText = 'See More';
          button.dataset.isCollapsed = 'true';
        }
      });
    });
  }

  // Event handler for sorting selector changes
  handleSelectorChange(event) {
    var sortSelectors = document.querySelectorAll(SORT_SELECTOR);
    var selectedValue = event.target.value;

    // Remove the event listener from the current element
    event.target.removeEventListener('change', this.handleSelectorChange);
    sortSelectors.forEach(otherSelector => {
      if (otherSelector !== event.target) {
        otherSelector.value = selectedValue;
      }
    });
    event.target.addEventListener('change', this.handleSelectorChange.bind(this));
  }

  // Method to create search parameters from form data
  createSearchParams(form) {
    if (!form) return '';
    var priceRangeElement = form.querySelector('price-range');
    var formData = new FormData(form);
    var searchParams = new URLSearchParams(formData);
    if (priceRangeElement) {
      var _Number, _Number2;
      var inputs = priceRangeElement.querySelectorAll('input');
      var minInput = inputs[0];
      var maxInput = inputs[1];
      var lowestPrice = (_Number = Number(minInput === null || minInput === void 0 ? void 0 : minInput.getAttribute('min'))) !== null && _Number !== void 0 ? _Number : null;
      var highestPrice = (_Number2 = Number(maxInput === null || maxInput === void 0 ? void 0 : maxInput.getAttribute('max'))) !== null && _Number2 !== void 0 ? _Number2 : null;

      // Ensure filter.v.price.gte is not below the lowest price
      var priceGte = Number(searchParams.get('filter.v.price.gte'));
      if (!isNaN(priceGte) && lowestPrice !== null && priceGte < lowestPrice) {
        searchParams.set('filter.v.price.gte', lowestPrice);
      }

      // Ensure filter.v.price.lte is not above the highest price
      var priceLte = Number(searchParams.get('filter.v.price.lte'));
      if (!isNaN(priceLte) && highestPrice !== null && priceLte > highestPrice) {
        searchParams.set('filter.v.price.lte', highestPrice);
      }
    }
    return searchParams.toString();
  }

  // Event handler for form submissions
  onSubmitForm(searchParams, event) {
    FiltersForm.renderPage(searchParams, event);
  }

  // Event handler for form input changes
  onSubmitHandler(event) {
    event.preventDefault();
    var sortFilterForms = document.querySelectorAll('filters-form form');
    var forms = [];
    var isMobile = event.target.closest('form').id === SORT_FORM_ID_MOBILE;
    sortFilterForms.forEach(form => {
      if (!isMobile) {
        if (form.id === SORT_FORM_ID_DESKTOP || form.id === FILTERS_FORM_ID) {
          forms.push(this.createSearchParams(form));
        }
      } else if (form.id === SORT_FORM_ID_MOBILE || form.id === FILTERS_FORM_ID) {
        forms.push(this.createSearchParams(form));
      }
    });
    this.onSubmitForm(forms.join('&'), event);
  }

  // Event handler for active filter clicks
  onActiveFilterClick(event) {
    event.preventDefault();
    var url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FiltersForm.renderPage(url);
  }
}
FiltersForm.filterData = [];
FiltersForm.searchParamsInitial = window.location.search.slice(1);
FiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('filters-form', FiltersForm);
FiltersForm.setListeners();

// Reset the price range to the minimum and maximum
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }
  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }
  setMinAndMaxValues() {
    var inputs = this.querySelectorAll('input');
    var minInput = inputs[0];
    var maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }
  adjustToValidValues(input) {
    var value = Number(input.value);
    var min = Number(input.getAttribute('min'));
    var max = Number(input.getAttribute('max'));
    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
customElements.define('price-range', PriceRange);
class FilterRemove extends HTMLElement {
  constructor() {
    super();
    var filterLink = this.querySelector('a');
    filterLink.setAttribute('role', 'button');
    filterLink.addEventListener('click', this.closeFilter.bind(this));
    filterLink.addEventListener('keyup', event => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }
  closeFilter(event) {
    event.preventDefault();
    var form = this.closest('filters-form') || document.querySelector('filters-form');
    form.onActiveFilterClick(event);
  }
}
customElements.define('filter-remove', FilterRemove);

// -------------------------------------
// Helpers
// -------------------------------------

// Limit the frequency of a function's execution
function debounce(fn, wait) {
  var _this = this;
  var t;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(t);
    t = setTimeout(() => fn.apply(_this, args), wait);
  };
}

// Function to handle keyup 'Escape' event to close details element
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  var openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  var summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}
function toggleFilters(action) {
  var filtersForm = document.querySelector(FILTERS_FORM_SELECTOR);
  var filters = filtersForm ? filtersForm.querySelectorAll(FILTER_ELEMENT) : [];
  if (filtersForm && filtersForm.classList.contains(CLOSED_FILTERS_CLASS) && filters.length > 0) {
    filters.forEach(function (filter) {
      if (filter && (action === 'open' ? !filter.hasAttribute(OPEN_ATTR) : filter.hasAttribute(OPEN_ATTR))) {
        action === 'open' ? filter.setAttribute(OPEN_ATTR, true) : filter.removeAttribute(OPEN_ATTR);
      }
    });
  }
}
function handleFiltersByViewport() {
  var breakpoint = window.matchMedia('(max-width: 1023px)');
  var action = breakpoint.matches ? 'close' : 'open';
  toggleFilters(action);
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', handleFiltersByViewport);
window.addEventListener('resize', handleFiltersByViewport);